module.exports = __webpack_public_path__ + "assets/img/news (19).9d838fcb.png";